import { render, staticRenderFns } from "./QuoteBanner.vue?vue&type=template&id=b862d0a2&scoped=true"
import script from "./QuoteBanner.vue?vue&type=script&lang=js"
export * from "./QuoteBanner.vue?vue&type=script&lang=js"
import style0 from "./QuoteBanner.vue?vue&type=style&index=0&id=b862d0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b862d0a2",
  null
  
)

export default component.exports